<template>
  <a-modal
    v-model="showModal"
    :title="title"
    width="68%"
    :footer="null"
    :maskClosable="false"
    :dialogStyle="{ top: '10%' }"
    @cancel="handleCancel"
  >
    <div style="text-align:right;"><span @click="showMasterManage" class="master_flow">主账号流量包</span>
    <master-flow-packet
      :visible="show.masterManage"
      :id="sonId"
      @master-flow-packet-visible="changeMasterManage"
    ></master-flow-packet>
      <update-price
        :visible="show.updatePrice"
        :record="record"
        @update-price-visible="changeUpdatePrice"
      ></update-price>
    </div> 
     <a-table
      :loading="loading"
      :columns="showColumns"
      :data-source="datas"
      :pagination="pagination"
      :rowKey="(record,i)=>{return i}"
      size="small"
    >
      <div slot="operation" slot-scope="text, record">
        <div v-if="record.bpmUserType != 1" class="row_record_operate row_record_edit">
          <a-icon
            class="edit"
            type="edit"
            @click.prevent="updatePrice(record)"
            title="修改价格"
          />
        </div>
        <div v-if="record.status == 1" class="row_record_operate row_record_del">
          <a-icon
            class="delete"
            type="delete"
            @click.prevent="del(record)"
            title=" 删除"
          />
        </div>
      </div>
      <div slot="count" slot-scope="text, record">
        <span>{{record.conut}}{{record.packet_unit=='G'?"GB":record.packet_unit}}</span>
      </div>
      <div slot="maxFlow" slot-scope="text, record">
        <span >{{record.maxFlow/1024}}</span>
      </div>
      <div slot="price_type" slot-scope="text, record">
        <span v-if="record.price_type == 0">{{record.days}}天</span>
        <span v-else>{{record.days}}月</span>
      </div>
    </a-table>
  </a-modal>
</template>
<script>
import { errMsg,warnMsg,successMsg } from '../../../utils/CommonUtils';
import masterFlowPacket from "./masterFlowPacketModal.vue"
import updatePrice from "./updatePriceModal.vue"
export default {
  props: ["visible","id"],
  components:{
    masterFlowPacket,
    updatePrice,
  },
  data() {
    return {
      title: "流量包管理",
      sonId: "",
      loading:true,
      showModal: false,
      record: "",
      show:{
          masterManage: false,
          updatePrice: false,
      },
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
        onChange: (current, pageSize) =>
          this.changeCurrentPage(current, pageSize),
        showTotal: () => `共${this.pagination.total}条记录`,
      },
      datas: [],
      showColumns: [
        {
          title: "国家",
          dataIndex: "country",
        },
        {
          title: "名称",
          dataIndex: "show_name",
        },
         {
          title: "套餐流量",
          dataIndex: "conut",
          scopedSlots: { customRender: "count" },
        },
        {
          title: "最大流量(MB)",
          dataIndex: "maxFlow",
          scopedSlots: { customRender: "maxFlow" },
        },
        {
          title: "套餐时长",
          dataIndex: "price_type",
          scopedSlots: { customRender: "price_type" },
        },
        {
          title: "本级价格(元)",
          dataIndex: "price_0_0",
        },
        {
          title: "下级价格(元)",
          dataIndex: "price_1_0",
        },
        {
          title: "操作",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
      ], 
    };
  },
  watch: {
    visible(val) {
      this.showModal = val;
      if(this.showModal){
        this.init()
        this.sonId = this.id
      }
    },
  },
  methods: {
    //改变页码调用此函数
    changeCurrentPage(currentPage) {
      this.pagination.current = currentPage;
    },
    changeMasterManage(val){
      this.show.masterManage = val
      this.init()
    },
    changeUpdatePrice(val,flag){
      this.show.updatePrice = val
      if(flag == 1){
        this.init()
      }
    },
    del(record) {
       let param =  {
           user: this.id,
           priceId: record.packetid,
           attachid: record.attachid,
           type: 2,
       }
      this.axios.post(this.baseUrl + "subAccountAddFlowPacet", param, {
          headers: { token: sessionStorage.getItem("token") },
        }).then((res) => {
          if (res.status == 200) {
            if (res.data.code == 0) {
              successMsg("删除成功");
              this.init()
            } else if (res.data.code == -1) {
              warnMsg("请先登录");
              setTimeout(() => {
                this.$router.push({ name: "login" });
              }, "2000");
            } else if (res.data.code == -2) {
              warnMsg("未查询到主账号流量包");
            }else if (res.data.code == -3) {
              warnMsg("删除失败");
            }
          } else {
            errMsg("删除失败");
          }
        }).catch(() => {
          errMsg("系统错误，请联系管理员。");
        });
    },
    handleCancel() {
      this.$emit("flow-visible", false);
    },
    init(){
      this.axios.post(this.baseUrl + "QueryCountryAndMoneyFoFlowPackage?sonId="+this.id,"",
        {headers: { token: sessionStorage.getItem("token") }}).then((res)=>{
        this.loading = false;
        if(res.status == 200){
           if(res.data.code == 0){
             this.datas = res.data.data
             this.pagination.total = res.data.count
           }else if(res.data.code == 1){
             this.datas = []
             this.pagination.total = 0
           }else if(res.data.code == -1){
              warnMsg("请先登录");
              setTimeout(() => {
                this.$router.push({ name: "login" });
              }, "2000");
           } 
        }else{  
          errMsg("查询数据失败")
        }
      }).catch(()=>{
        this.loading = false;
        errMsg("系统错误，请联系管理员")
      })
    },
    showMasterManage(){
      this.show.masterManage = true
    },
    updatePrice(record) {
      this.record = record
      this.show.updatePrice = true
    },
  },
};
</script>
<style scoped>

.master_flow{
  display: inline-block;
  width: 100px;
  height: 30px;
  border: 1px solid rgb(211, 211, 211);
  text-align: center;
  line-height: 30px;
  border-radius: 5px;
}
.master_flow:hover{
  cursor: pointer;
  color:  rgb(78, 78, 255);
  border: 1px solid  rgb(78, 78, 255);
}

.row_record_operate {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  margin-left: 10px;
}

.edit:hover,
.delete:hover {
  color: rgb(137, 208, 255);
  border: 1px solid rgb(137, 208, 255);
}
.edit:active,
.delete:active {
  color: rgb(66, 178, 252);
}


::v-deep .ant-modal-body{
  padding: 15px 24px 24px;
}
/* 表头样式 */
::v-deep .ant-table-thead > tr > th {
  background-color: white;
  padding: 12px 8px 3px !important;
}
/**表记录样式 */
::v-deep .ant-table-tbody > tr > td {
  padding: 2px 8px !important;
}
::v-deep .ant-table-small {
  border: none;
}
/* 分页位置 */
::v-deep .ant-table-pagination.ant-pagination {
  float: none;
  text-align: center;
}
</style>